import type { PipelineProgress } from "../api/types";

// Friendly labels for the server's PIPELINE_STAGES names. Unknown names (version skew
// between console and worker) fall back to the raw stage string.
const STAGE_LABELS: Record<string, string> = {
  unpack: "Unpacking bundle",
  validate: "Validating data",
  anti_fraud: "Anti-fraud check",
  frames: "Extracting frames",
  build_mcap: "Building MCAP",
  qc: "Quality checks",
  stera_eval: "Stera evaluation",
  annotations: "AI annotations",
  render_rrd: "Rendering rerun",
  face_blur: "Face blur",
  episode_export: "Episode export",
  calibration_voice: "Calibration voice",
  datacard: "Data card",
  clips_ai_recommendation: "AI clip suggestions",
  finalize: "Finalizing",
  persist: "Persisting to storage",
};

/** Live pipeline position for an in-flight recording: stage label, step count and a bar. */
export default function PipelineProgressBar({ progress }: { progress: PipelineProgress }) {
  const label = STAGE_LABELS[progress.stage] ?? progress.stage;
  // The current stage is mid-flight, so fill to the middle of its slot; step 0 means the
  // console doesn't know this stage's position — show a sliver rather than an empty bar.
  const pct =
    progress.step > 0 ? Math.round(((progress.step - 0.5) / progress.total) * 100) : 4;
  return (
    <div
      className="pipe-progress"
      title={`Pipeline stage ${progress.step}/${progress.total}: ${progress.stage}`}
    >
      <div className="pipe-progress-head">
        <span className="pipe-progress-label">{label}</span>
        {progress.step > 0 && (
          <span className="pipe-progress-count">
            {progress.step}/{progress.total}
          </span>
        )}
      </div>
      <div className="pipe-progress-track">
        <div className="pipe-progress-fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
